
import React from "react";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { useGuideUpload } from "@/hooks/use-guide-upload";
import { Guide } from "@/types/guides";
import { useQueryClient } from "@tanstack/react-query";

interface GuideUploadProps {
  guide: Guide;
}

export function GuideUpload({ guide }: GuideUploadProps) {
  const { uploadGuide, isUploading } = useGuideUpload();
  const queryClient = useQueryClient();

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file || file.type !== 'application/pdf') {
      toast.error("Please select a PDF file");
      return;
    }

    const publicUrl = await uploadGuide(file, guide);
    if (publicUrl) {
      toast.success("Guide uploaded successfully");
      // Refresh guides data to reflect the updated download_url
      queryClient.invalidateQueries({ queryKey: ['guides'] });
    }
  };

  return (
    <div className="relative">
      <Button 
        className="bg-grandpal-green-dark text-white hover:bg-grandpal-green-dark/90 w-full"
        onClick={() => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'application/pdf';
          input.onchange = (e) => {
            if (e && e.target) {
              handleFileUpload(e as unknown as React.ChangeEvent<HTMLInputElement>);
            }
          };
          input.click();
        }}
        disabled={isUploading}
      >
        <Upload className="mr-2 h-5 w-5" />
        {isUploading ? 'Uploading...' : 'Upload Guide'}
      </Button>
    </div>
  );
}
